/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Reading_FileInputs */



/**
* | output |
* | --- |
* | "Reading file" |
*
* @param {Chat_Tool_Reading_FileInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_reading_file = /** @type {((inputs?: Chat_Tool_Reading_FileInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Reading_FileInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Lese Datei")
	return /** @type {LocalizedString} */ ("Reading file")
});